export default {
	// General
	VERSION: 'version',
	BUILD: 'build',
	ACTION_COL_KEY: 'action',
	DATA_VIEW_LIST_ACTION: 'viewlist',
	DATA_VIEW_ACTION: 'view',
	DATA_ADD_ACTION: 'add',
	DATA_EDIT_ACTION: 'edit',
	DATA_PROFILE_ACTION: 'profile',
	ADD_PERMISSION_KEY: 'add',
	EDIT_PERMISSION_KEY: 'edit',
	DELETE_PERMISSION_KEY: 'delete',
	ADD_FORM_PERMISSION_KEY: 'add_form',
	EDIT_FORM_PERMISSION_KEY: 'edit_form',
	TOOLTIP_ORIGIN_FORM_FIELD: 'FORM_FIELD',
	INLINE_RICHTEXT_UI_KEY: '_INLINE_RICHTEXT_UI_KEY',
	SECTION_TITLE_KEY: 'section_title',
	SECTION_SUB_TITLE_KEY: 'section_sub_title',
	PAGE_DATA_ROWS_COUNT: '_PAGE_DATA_ROWS_COUNT_',
	TOOLTIP_PLACEMENT_KEY: '___TOOLTIP_PLACEMENT',
	// API Provided
	ROW_SPACE: 'row_space',
	__DEFAULT_EVENT_PATH__: 'default_microsite',
	// Window FNs
	HANDLE_LOGOUT_FN: '_HANDLE_LOGOUT_FN_',
	// Window Variables
	_TERMINOLOGY_: '__APP_TERMINOLOGY__',
	APP_VERSION: 'APP_VERSION',
	APP_BUILD_NUMBER: 'APP_BUILD_NUMBER',
	VERSION_PROCESSING_KEY: 'VERSION_PROCESSING',
	BUILD_NUMBER_PROCESSING_KEY: 'BUILD_NUMBER_PROCESSING',
	APP_UPDATE_TYPE_KEY: 'APP_UPDATE_TYPE',
	APP_UPDATE_MODAL_VISIBLE_KEY: 'APP_UPDATE_MODAL_VISIBLE',
	VERSION_UPDATE_CHECKED_KEY: 'VERSION_UPDATE_CHECKED',
	APP_MAINTENANCE_ETA_KEY: 'APP_MAINTENANCE_ETA',
	APP_MAINTENANCE_PERIOD_KEY: 'APP_MAINTENANCE_PERIOD',
	BUILD_UPDATE_CHECKED_KEY: 'BUILD_UPDATE_CHECKED',
	LAST_UPDATE_CHECKED_TIMESTAMP_KEY: 'LAST_UPDATE_CHECKED_TIMESTAMP',
	APP_MESSAGE: 'APP_MESSAGE',
	APP_NOTIFICATION: 'APP_NOTIFICATION',
	APP_MODAL: 'APP_MODAL',
	APP_NAVIGATE: 'APP_NAVIGATE',
	APP_HAS_NAVIGATION_ACTIVITY: 'APP_HAS_NAVIGATION_ACTIVITY',
	AUCTION_SCROLL_RESTORE: '_AUCTION_SCROLL_RESTORE_',
	// Session Variables
	INIT_APP_BUILD_NUMBER_KEY: 'INIT_APP_BUILD_NUMBER',
	// Local Storage
	SPLASH_LOGO: 'SPLASH_LOGO',
	UPCOMING_MAINTENANCE_MODAL_CLOSED_FOR: 'UPCOMING_MAINTENANCE_MODAL_CLOSED_FOR',
	GUEST_CHECKOUT_INFO: 'GUEST_CHECKOUT_INFO',
	OTP_METHOD_RES: 'OTP_METHOD_RES',
	OTP_METHOD_LABEL: 'OTP_METHOD_LABEL',
	OTP_RESENT_INPUT: 'OTP_RESENT_INPUT',
	ORIGIN_FROM_TICKET_CHECKOUT_CHANGE_ORDER: 'ORIGIN_FROM_TICKET_CHECKOUT_CHANGE_ORDER',
	TICKET_CHECKOUT_STATE: '__TICKET_CHECKOUT_STATE__',
	// Module
	MODULES: {
		invoices: 'bb_emma_invoices',
		events: 'bb_emma_events',
		guests: 'bb_emma_guests',
		vouchers: 'bb_emma_vouchers',
	},
	// Template
	TEMPLATES: {},
	// Route Key
	ROUTE_KEYS: {},
	// Field
	FIELDS: {
		// API
		voucherId: `voucherISbb_emma_vouchersID`,
		eventId: `eventISbb_emma_eventsID`,
		guestId: `guestISbb_emma_guestsID`,
		eventTicketTypeID: `ticket_typeISbb_emma_event_ticketsID`,
		guestTicketID: `ticketISbb_emma_guests_ticketsID`,
		mobile: ['guest_mobile', 'mobile'],
		rsvp_status: 'rsvp_statusISLIST_Awaiting_Yes_No',
		uk_tax_payer: 'uk_tax_payerYN',
		guest_pays_fees: 'guest_pays_feesYN',
		guest_pays_fees_default: 'guest_pays_fees_defaultYN',
		processing_fee: 'processing_feeCUR',
		voluntary_contribution_amount: 'voluntary_contribution_amountCUR',
		voluntary_contribution_amountCUR_display: 'voluntary_contribution_amountCUR_display',
		order_total: 'order_totalCUR',
		request_invoice: 'request_invoiceYN',
		idempotency_key: 'idempotency_key',
		guest_checkout_enabled: 'guest_checkout_enabledYN',
		ticket_bundle_id: 'bundleISbb_emma_event_tickets_bundlesID',
		countryId: 'streetcountryISbb_countriesID',
		checkin_status: `checkin_statusISLIST_In_Out`,
		address_lookup: 'address_lookup',
		orderId: 'orderISbb_emma_ordersID',
		lotId: 'lotISbb_emma_lotsID',
		secure_pin: 'secure_pin',
		anonymous: 'anonymousYN',
		agendas: 'agendasYN',
		eventContentId: `contentISbb_emma_event_contentID`,
	},
	// Query Params
	QUERY_PARAMS: {
		TEMPLATE: 'template',
		REDIRECT: `_redirect`,
		USER_TOKEN: `user_token`,
		PREVIEW: `preview`,
		EMAIL: 'email',
	},
	// DOM Class
	LOADING_INDICATOR_CLASS: 'loading-indicator',
	LOADING_INDICATOR_ICON_CLASS: 'loading-indicator-icon',
	C_APP_ERROR_POPUP_CLASS: 'common-app-error-popup',
	ACTION_DROPDOWN_TRIGGER_BTN: 'action-dropdown-trigger-btn',
	ANT_TABLE_ACTION_BTN: 'ant-table-action-button',
	ANT_DRAWER_BODY_CLASS: `ant-drawer-body`,
	ANT_MODAL_BODY_CLASS: `ant-modal-body`,
	SCREEN_AS_PAGE_DYNAMIC_ELEMENT: 'screen-as-page-dynamic-element',
	PAGE_SUBTITLE_CLASS: 'page-main-subtitle',
	APP_COMMON_BACK_BTN_CLASS: 'app-common-back-btn',
	APP_MODAL_TITLE_CLASS: '_APP_MODAL_TITLE_',
	// DOM ID's
	APP_HEADER: '_APP_HEADER_',
	APP_BODY_ID: 'BLUE_BOX_EMMA_MICROSITE_APP_BODY',
	FULLSCREEN_CONTAINER_ID: '__FULLSCREEN_CONTAINER__',
	MAINTENANCE_MODAL_TRIGGER_BTN_ID: 'MAINTENANCE_MODAL_TRIGGER_BTN',
	UPCOMING_MAINTENANCE_MODAL_TRIGGER_BTN_ID: 'UPCOMING_MAINTENANCE_MODAL_TRIGGER_BTN',
	APP_LEVEL_UPDATE_MODAL_TRIGGER_BTN_ID: 'APP_LEVEL_UPDATE_MODAL_TRIGGER_BTN',
	TEAMS_SECTION: 'TEAMS_SECTION',
	BASE_VIEW_WRAPPER_ID: 'APP_BASE_VIEW_WRAPPER_ID',
	TOP_PARALLAX_CONTAINER_ID: 'TOP_PARALLAX_CONTAINER_ID',
	APP_TOP_BANNER: 'APP_TOP_BANNER',
	PAGE_TOP_DYN_ALERT_WRAPPER_ID: 'PAGE_TOP_DYN_ALERT_WRAPPER_ID',
	TIMEOUT_COUNTDOWN_UI_WRAPPER: `_TIMEOUT_COUNTDOWN_UI_WRAPPER_`,
	// Filters
	// Text
	LOADING_COMPONENT_MSG: ``,
	// Headers
	HEADERS: {
		EVENT_ID: 'X-EMMA-Event-ID',
	},
	// Others
	PAYMENT_ORIGIN: {
		DYN: 'dyn_payment',
		AUCTION: 'auction',
		DONATION: 'donation',
		RAFFLE: 'raffle',
		TICKET: 'ticket',
	},
	AUCTION_TYPES: {
		BUY_NOW_ITEM: `buy_now_itemYN`,
		SEALED_BID_ITEM: 'sealed_bid_itemYN',
		COMPETITIVE_BID_ITEM: 'competitive_bid_itemYN', // Silent Auction
		LIVE_AUCTION_ITEM: 'live_auction_itemYN',
		SPONSOR_ITEM: 'sponsor_itemYN',
		WITHOUT_BIDS: 'without_bidsYN',
	},
	STRIPE_LOG_TRX_TYPES: {
		CREATE_PAYMENT_INTENT: 'createPaymentIntent',
		CONFIRM_PAYMENT_INTENT: 'confirmPaymentIntent',
	},
	PUSHER_CHANNELS: {
		/* Most of the time this pusher channel name and pusher event name will be same */
		BID_DATA_PUSH: 'bid-data-push',
		LOT_DATA_PUSH: 'lot-data-push',
		BID_DATA_UPDATE_ALERT: 'bid-data-update-alert',
	},
	PUSHER_EVENTS: {},
	DYNAMIC_CONTENT_TYPES: {
		EVENT_DATA: 'event_data',
		TOTAL_RAISED: 'total_raised',
		DONATION_PROGRESS: 'donation_progress',
		DONATION_FORM: 'donation_form',
		PLEDGE_LISTING: 'pledge_listing',
		IG_LISTING: 'individual_giving_listing',
		AUCTION_LOTS_LISTING: 'auction_lots_listing',
		BUY_NOW_LISTING: 'buy_now_listing',
	},
	UP_SELL_TYPES: {
		BUY_NOW: 'buy_now',
		PRIZE_DRAW: 'raffle',
		PLEDGE: 'pledge',
	},
	AJAX_HEADER: {
		REFERER: 'X-EMMA-Referer',
		DOMAIN_REFERER: 'X-EMMA-Domain-Referer',
	},
}
